import React, { useEffect, useMemo, useState } from "react";
import { SCENES } from "./ReelScenes";
import "./igReels.css";

export const AnimatedReel = ({ reel, playing = true, loop = true, onEnd, showProgress = true, className = "", testId }) => {
  const scenes = useMemo(() => reel.scenes(), [reel]);
  const [idx, setIdx] = useState(0);
  const [run, setRun] = useState(0);

  useEffect(() => { setIdx(0); setRun((r) => r + 1); }, [reel]);

  useEffect(() => {
    if (!playing) return;
    const t = setTimeout(() => {
      if (idx < scenes.length - 1) return setIdx(idx + 1);
      if (onEnd) onEnd();
      if (loop) { setIdx(0); setRun((r) => r + 1); }
    }, scenes[idx].duration);
    return () => clearTimeout(t);
  }, [idx, playing, loop, scenes, onEnd]);

  const scene = scenes[idx];
  const Scene = SCENES[scene.type];
  return (
    <div className={`igr-frame ${className}`} data-testid={testId}>
      {showProgress && (
        <div className="igr-progress">
          {scenes.map((s, i) => (
            <div key={i}>
              <span
                key={`${run}-${idx}-${i}`}
                className={i === idx && playing ? "run" : ""}
                style={{ transform: `scaleX(${i < idx ? 1 : 0})`, animationDuration: `${s.duration}ms` }}
              />
            </div>
          ))}
        </div>
      )}
      <Scene key={`${run}-${idx}`} s={scene} />
    </div>
  );
};
